var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warningBar"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"warningText"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warningIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("warning")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01caab60","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/ModularComponents/waningbar.vue
// module id = 572
// module chunks = 0